export default {
  amountMustNotExceedCurrentOrderAmount:
    "Amount must not exceed current order amount",
  clipboardCopyMessage: "Number copied to clipboard",
  deliveryTime: "Delivery Time",
  driver: "Driver",
  hideHistory: "Hide History",
  newLocation: "New Location",
  receiver: "Receiver",
  reportProblem: "Report A Problem",
  showHistory: "Show History",
  singleOrderTracking: "Order Tracking",
  trackOrder: "Track Order",
};
